import { render, staticRenderFns } from "./Rule.Service.vue?vue&type=template&id=ac613810&"
import script from "./Rule.Service.vue?vue&type=script&lang=js&"
export * from "./Rule.Service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports